import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

const STORAGE_NAME = 'name';
export const useUserStore = defineStore('user', () => {
  const userName = ref(localStorage.getItem(STORAGE_NAME));

  const getUserName = computed(() => userName.value);
  const setUserName = (val: string) => {
    userName.value = val;
    localStorage.setItem(STORAGE_NAME, val);
  };

  const deleteUserName = () => {
    userName.value = null;
    localStorage.removeItem(STORAGE_NAME);
  };

  return { getUserName, setUserName, deleteUserName };
});
